module.exports = __webpack_public_path__ + "img/excel.7e26c2ea.png";